import { render, staticRenderFns } from "./BufferAccountsTable.vue?vue&type=template&id=cb1940b4&"
import script from "./BufferAccountsTable.vue?vue&type=script&lang=ts&"
export * from "./BufferAccountsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports